import { render } from "./HowCameUp.vue?vue&type=template&id=06a679bb&scoped=true"
const script = {}

import "./HowCameUp.vue?vue&type=style&index=0&id=06a679bb&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a679bb"]])

export default __exports__